import { Redirect } from "react-router";
import { RouteConfig } from "react-router-config";

import { SoulEntityType } from "@tsp-domains/soul-entities/enums";
import { WorkItemEntityType } from "@tsp-domains/work-items/enums";

import { AboutPage } from "./pages/About";
import { AuthPage } from "./pages/Auth";
import { CompliancePage } from "./pages/Compliance";
import { ContactPage } from "./pages/Contact";
import { ExternalDispatchPage } from "./pages/ExternalDispatch";
import { LegalPage } from "./pages/Legal";
import { NotFoundPage } from "./pages/NotFound";
import { PayoutMethodsPage } from "./pages/PayoutMethods";
import { SSOLandingPage } from "./pages/SSOLanding";
import InvoicesListingPage from "./pages/invoices";
import LinkingMcPayAccount from "./pages/linking-mc-pay-account";
import LinkingPayseraAccount from "./pages/linking-paysera-account";
import MainPage from "./pages/main";
import ManualRegistrationPage from "./pages/manual-registration";
import SettingsPage from "./pages/settings";
import WorkItemsListingPage from "./pages/work-items-listing";
import WorkItemsListingWithSoulEntityPage from "./pages/work-items-listing-with-soul-entity";

export const routes: Array<RouteConfig> = [
  {
    path: "/",
    exact: true,
    component: MainPage,
  },
  {
    path: "/auth",
    component: AuthPage,
  },
  {
    path: "/sso/landing",
    component: SSOLandingPage,
  },
  {
    path: "/manual-registration",
    component: ManualRegistrationPage,
  },
  {
    path: "/invoices",
    component: InvoicesListingPage,
  },
  {
    exact: true,
    path: ["/accounts", "/accounts/:contractorAccountUuid"],
    component: PayoutMethodsPage,
  },
  {
    path: "/sso/logout",
    component: () => <Redirect to="/" />,
  },
  {
    path: "/compliance/about",
    component: AboutPage,
  },
  {
    path: "/compliance/legal",
    component: LegalPage,
  },
  {
    path: "/compliance/contact",
    component: ContactPage,
  },
  {
    path: "/compliance",
    component: CompliancePage,
  },
  {
    path: "/dispatch/:entity",
    component: ExternalDispatchPage,
  },
  {
    exact: true,
    path: [
      "/work-registration",
      `/work-registration/:flow(create)/:type(${WorkItemEntityType.CUSTOM_PAYMENT})`,
      `/work-registration/:flow(create)/:type(${WorkItemEntityType.CUSTOM_WORK})`,
      `/work-registration/:flow(update)/:type(${WorkItemEntityType.CUSTOM_PAYMENT})/:uuid`,
      `/work-registration/:flow(update)/:type(${WorkItemEntityType.CUSTOM_WORK})/:uuid`,
    ],
    component: WorkItemsListingPage,
  },
  {
    exact: true,
    path: [
      `/work-registration/:type(${SoulEntityType.ORDER})/:orderUuid`,
      `/work-registration/:type(${SoulEntityType.ORDER})/:orderUuid/:flow(create)`,
      `/work-registration/:type(${SoulEntityType.ORDER})/:orderUuid/:flow(update)/:uuid`,

      `/work-registration/:type(${SoulEntityType.CONTENT})/:contentType/:contentUuid`,
      `/work-registration/:type(${SoulEntityType.CONTENT})/:contentType/:contentUuid/:flow(create)`,
      `/work-registration/:type(${SoulEntityType.CONTENT})/:contentType/:contentUuid/:flow(update)/:uuid`,
    ],
    component: WorkItemsListingWithSoulEntityPage,
  },
  {
    exact: true,
    path: "/settings",
    component: SettingsPage,
  },
  {
    path: "/paysera/oauth",
    component: LinkingPayseraAccount,
  },
  {
    exact: true,
    path: "/mcpay/token",
    component: LinkingMcPayAccount,
  },
  {
    component: NotFoundPage,
  },
];
